<template>
    <div id="qymanager">
        <div class="tos">
           <el-form :inline="true" :model="regionalQueryPageDto" label-width="100px"  class="demo-form-inline">
              <el-form-item label="关键字：">
                 <el-input v-model="regionalQueryPageDto.keyWords"></el-input>
              </el-form-item>
              <el-form-item>
                 <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
              </el-form-item>
           </el-form>
           <el-button class="right-item"  type="primary" @click=newoks()>添加区域经理</el-button>
        </div>
        <div class="tableform">
          <el-table
              :data="tableData"
              border
              stripe
              :cell-style="{'text-align':'center'}"
              :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
              :span-method="arraySpanMethod"
              ref="multipleTable"
              tooltip-effect="dark"
              :default-sort="{prop: 'insectCountThreeDaysStr', order: 'descending'}"
              style="width: 100%"
              v-loading="loading"
              >
              <el-table-column
                 prop="areaNames"
                 label="业务区域"
                 >
                 <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.areaNames" :key="index">
                        <span>{{ item.areaName }}，</span>
                        </span>
                </template>
              </el-table-column>
              <el-table-column
                 prop="nickName"
                 label="姓名"
                 >
                 <template slot-scope="{row:{ nickName }}">
                 {{ nickName|| "—" }}
                 </template>
              </el-table-column>
              <el-table-column
                 prop="phone"
                 label="电话"
                 >
                 <template slot-scope="{row:{ phone }}">
                 {{ phone|| "—" }}
                 </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                    <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                    <i title="删除"  class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
           </el-table>
           <div class="btnbox">
              <el-pagination
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 :current-page="regionalQueryPageDto.pageNum"
                 :page-sizes="[10, 15, 20]"
                 :page-size="regionalQueryPageDto.pageSize"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="this.totals">
              </el-pagination>
           </div>
        </div>
         <!-- 添加区域经理弹框 -->
       <el-dialog title="添加区域经理" :visible.sync="increase" width="32%" class="zcyhtk">
            <el-form ref="addRegional" :model="addRegional"  label-width="80px" label-position="right" size="small">
                <el-form-item label="姓名：" prop="position">
                    <el-select v-model="addRegional.userIds" multiple placeholder="请选择">
                        <el-option
                        v-for="item in namelist"
                        :key="item.userId"
                        :label="item.nickName"
                        :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务区域：" prop="position">
                     <el-cascader 
                           :options="xintableData" 
                           v-model="addRegional.treeCode" 
                           :props="xinaderProps" 
                           @change="handleChange"
                           clearable
                           >
                        </el-cascader>
                        <!-- <el-button type="primary" @click="pjification()" plain>确定</el-button> -->
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('addRegional',addRegional)">确 定</el-button>
            </div>
       </el-dialog>
         <!-- 编辑区域经理弹框 -->
         <el-dialog title="编辑区域经理" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk" @close='closeDialog'>
            <el-form ref="addRegional" :model="addRegional"  label-width="80px" label-position="right" size="small">
                <el-form-item label="姓名：" prop="position">
                    <el-select v-model="addRegional.userIds" multiple placeholder="请选择">
                        <el-option
                        v-for="item in namelist"
                        :key="item.userId"
                        :label="item.nickName"
                        :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务区域：" prop="position">
                     <el-cascader
                           :options="xintableData"
                           v-model="addRegional.treeCode"
                           :props="xinaderProps"
                           @change="handleChange"
                           clearable
                           >
                        </el-cascader>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="bjsubmitForm('addRegional',addRegional)">确 定</el-button>
            </div>
       </el-dialog>
    </div>
    </template>
    <script>
       export default {
       name:'qymanager',
       data(){
        return{
           regionalQueryPageDto:{
              pageNum:1,
              pageSize:10,
              keyWords:null,
           },
           tableData: [],
           totals:10,
           increase:false,
           dialogFormVisible:false,
           spanArr: [],
           pos: 0,
           regionaIdl:null,
           addRegional:{
              treeCode:[],
              userIds:[],
              remark:''
           },
           namelist:[],
           loading:false,
           xintableData:[],
           xinaderProps: {
            value: 'treeCode',
            label: 'name', 
            children: 'areaAllQueryVos',
            multiple: true,
            checkStrictly: true,
            emitPath: false, // 只返回最后一级的值
            expandTrigger: 'hover',
         },
        }
       },
       created(){
        this.getlist(this.regionalQueryPageDto)
       },
       mounted(){
       },
       methods:{
        into(){
            this.spanArr = [];
            this.pos = 0;
        },
        getlist(regionalQueryPageDto) {
           this.$api.cxqyjlqueryPage(regionalQueryPageDto)
           .then((res) => {
                 if (res.data.code == 200) {
                    let data = res.data.data.records
                    let dateLiat = []
                    data.forEach(element => {
                        element.managerUserVos.forEach(item => {
                            let data = {
                                areaNames:element.areaNames,
                                areaNames:element.areaNames,
                                nickName:item.nickName,
                                phone:item.phone,
                                regionalId:element.regionalId,
                            }
                            dateLiat.push(data)
                        });
                    });
                    this.tableData = dateLiat
                    this.totals = res.data.data.total
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (i === 0) {
                            this.spanArr.push(1);
                            this.pos = 0;
                        } else {
                            if (this.tableData[i].regionalId === this.tableData[i - 1].regionalId) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0); 
                            }else {
                            this.spanArr.push(1); 
                            this.pos = i;
                            }
                        }
                    }
                } else {
                this.$message.error(res.data.message)
                }
           })
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        // 竖向合并
            if (columnIndex === 0) {
                const _row = this.spanArr[rowIndex]; 
                const _col = _row > 0 ? 1 : 0; 
                return {
                rowspan: _row,
                colspan: _col,
                };
            } else if (columnIndex === 3) {
                const _row = this.spanArr[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                rowspan: _row,
                colspan: _col,
                };
            }
        },
        newoks() {
            this.increase = true
            this.userinformation()
            this.hqssqmation()
        },
        userinformation(){
            this.$api.xlhqhqueryUser({
                username:null
            })
            .then((res) => {
                if (res.data.code == 200) {
                    this.namelist = res.data.data
                } else {
                this.$message.error(res.data.message)
                }
            })
        },
        hqssqmation(){
            this.$api.hqssqlist()
            .then((res) => {
                if (res.data.code == 200) {
                    this.xintableData = res.data.data
                } else {
                this.$message.error(res.data.message)
                }
            })
        },
        submitForm(){
            this.$api.tjquyjaddRegional(this.addRegional).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.addRegional={
                        treeCode:[],
                        userIds:[],
                        remark:''
                    },
                    this.into()
                    this.loading = true;
                    this.getlist(this.regionalQueryPageDto)
                    setTimeout(() => {
                    this.loading = false;
                    }, 1000);
                    this.$message.success(res.data.message)
                } else {
                this.$message.error(res.data.message)
                }
            })
        },
        bjsubmitForm(){
            console.log(this.addRegional,'addRegionaladdRegionaladdRegional');
            this.$api.editRegional({
                regionId:this.regionaIdl,
                remark:null,
                treeCode:this.addRegional.treeCode,
                userIds:this.addRegional.userIds
            }).then((res) => {
                if (res.data.code == 200) {
                    this.dialogFormVisible = false
                    this.addRegional={
                        treeCode:[],
                        userIds:[],
                        remark:''
                    },
                    this.into()
                    this.loading = true;
                    this.getlist(this.regionalQueryPageDto)
                    setTimeout(() => {
                    this.loading = false;
                    }, 1000);
                    this.$message.success(res.data.message)
                } else {
                this.$message.error(res.data.message)
                }
            })
        },
        handleChange(value) {
            let dataList= value;
            let datafour = []
            let datasix = []
            let dataDelfour = []
            let dataDelsix = []
            dataList.forEach(item => {
                if(item.length == 4) {
                datafour.push(item)
                }
            });
            datafour.forEach(item => {
                dataList.forEach(element => {
                if(item !== element) {
                    let foursa = element.slice(0,4)
                    if(item == foursa) {
                    dataDelfour.push(element)
                    }
                }
                });
            });
            dataList = dataList.filter(item => !dataDelfour.includes(item));
            dataList.forEach(item => {
                if(item.length == 6) {
                datasix.push(item)
                }
            });
            datasix.forEach(item => {
                dataList.forEach(element => {
                if(item !== element) {
                    let foursa = element.slice(0,6)
                    if(item == foursa) {
                    dataDelsix.push(element)
                    }
                }
                });
            });
            dataList = dataList.filter(item => !dataDelsix.includes(item));
            this.addRegional.treeCode = dataList
        },
        bianjiClick(row) {
            this.regionaIdl = row.regionalId
            this.dialogFormVisible = true;
            this.userinformation()
            this.hqssqmation()
            this.bjtsClick()
        },
        bjtsClick(){
         this.$api.hqywqyxqdetail({
            regionalId:this.regionaIdl
            }).then((res)=>{
               if (res.data.code == 200) {
                 let datalist = res.data.data
                 let nameinfo = []
                 let treeCodeinfo = []
                 datalist.managerUserVos.forEach(element => {
                    nameinfo.push(element.userId)
                 });
                 datalist.areaNames.forEach(element => {
                    treeCodeinfo.push(element.treeCode)
                 });
                 this.addRegional.userIds = nameinfo
                 this.addRegional.treeCode = treeCodeinfo
               } else {
                  this.$message.error(res.data.message)
               }
         })
      },
        dels(e) {
            console.log(e,'eeeeeeeeee');
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.deleteRegional({
                    regionalId:e.regionalId
                }).then((res) => {
                if(res.data.code==200){
                    this.into()
                    this.loading = true;
                    this.getlist(this.regionalQueryPageDto)
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }
                })
            }).catch(() => {
                this.$message({
                type: 'info',
                message: '已取消删除'
                });          
            });
        },
        closeDialog(){
            this.xgtkdfdqx()
        },
        xgtkdfdqx(){
            this.dialogFormVisible = false;
            this.addRegional={
                treeCode:[],
                userIds:[],
                remark:''
            },
            this.regionaIdl = null
        },
        sjhsearchFor(){
            this.into()
            this.loading = true;
            this.getlist(this.regionalQueryPageDto)
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        handleCurrentChange(val) {
            this.regionalQueryPageDto.pageNum = val
            this.into()
            this.loading = true;
            this.getlist(this.regionalQueryPageDto)
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        handleSizeChange(val) {
            this.regionalQueryPageDto.pageSize = val
            this.into()
            this.loading = true;
            this.getlist(this.regionalQueryPageDto)
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        }
       }
    </script>
    <style scoped>
 #qymanager {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    padding:0 0 0 30px;
    box-sizing: border-box;
 }
 .tos {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    /* background: yellow; */
    margin-bottom: 20px;
    margin-left: -30px;
  }
  .elrow{
    box-sizing: border-box;
    width: 20%;
    margin-top: -6px;
    margin: 0 40px 0 20px;
  }
  .elrowleft{
    width: 80%;
    float: left;
    box-sizing: border-box;
  }
  .elrowleft input{
    border: 2px solid #1b93ed !important;
    border-radius: 0 !important;
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #929da5;
    box-sizing: border-box;
    color: #1f3d35;
    font-size: 14px;
    height: 36px;
    line-height: 1;
    outline: none;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .elrowcontent{
    width: 16.66667%;
    float: left;
    box-sizing: border-box;
  }
  .search-btn {
    height: 36px;
    width: 100px;
    background: #1b93ed;
    border: 2px solid #1b93ed;
    margin: 0;
    padding: 0;
    color: #fff;
    cursor: pointer;
  }
  .right-item {
    margin-left: auto; /* Pushes the item to the right */
  }
  .tos /deep/ .el-form-item {
      margin-bottom: 0 !important;
  }
  .btnbox {
    /* background: pink; */
    display: flex;
    width: 40%;
    align-items: center;
    justify-content: space-around;
    margin: auto;
    margin-top: 30px;
 }
 .zcyhtk /deep/ .el-form-item__label {
    width: 90px !important;
 }
 .zcyhtk /deep/ .el-form-item__content {
    margin-left: 90px !important;
 }
    </style>


// WEBPACK FOOTER //
// src/components/xtglwxpart/qymanager.vue